import { createContext, useContext } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { pwaInfo } from "virtual:pwa-info";

console.log(pwaInfo);

const ServiceWorkerContext = createContext(null);

export const useServiceWorker = () => {
  const ctx = useContext(ServiceWorkerContext);
  if (!ctx)
    throw new Error(
      "useServiceWorker must be used within ServiceWorkerProvider"
    );
  return ctx;
};

const ServiceWorkerProvider = ({ children }) => {
  // replaced dynamically
  const buildDate = "__DATE__";
  // replaced dyanmicaly
  const reloadSW = "__RELOAD_SW__";

  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, r) {
      console.log(`Service Worker at: ${swUrl}`);
      // @ts-expect-error just ignore
      if (reloadSW === "true") {
        r &&
          setInterval(() => {
            console.log("Checking for sw update");
            r.update();
          }, 20000 /* 20s for testing purposes */);
      } else {
        console.log("SW Registered: " + r);
      }
    },
    onRegisterError(error) {
      console.log("SW registration error", error);
    },
  });

  const reload = () => {
    console.log("Reloading SW");
    updateServiceWorker(true);
  };

  const close = () => {
    setOfflineReady(false);
    setNeedRefresh(false);
  };

  return (
    <ServiceWorkerContext.Provider
      value={{
        needRefresh,
        reload,
        close,
      }}
    >
      {children}
      {/* <div style={{ visibility: "hidden" }}>{buildDate}</div> */}
    </ServiceWorkerContext.Provider>
  );
};

export default ServiceWorkerProvider;
